<template lang="pug">
.rc
  .rc__card
    h1.rc__title Recuperar contraseña
    p.rc__text
      | Ingresa tu correo electrónico asociado a tu cuenta de Samtek Center para recibir un enlace de recuperación
    form.rc__form(novalidate @submit.prevent="onSubmit")
      .rc__field(:class="{ 'rc__field--error': errorEmail }")
        label.rc__label(for="rc-email") Correo
        .rc__control
          input#rc-email.rc__input(
            v-model.trim="email"
            type="email"
            autocomplete="email"
            placeholder="Ingresa tu Correo"
          )
          p.rc__error(v-if="errorEmail") {{ errorEmail }}
      .rc__actions
        button.rc__btn.rc__btn--primary(type="submit" :disabled="loading")
          | Enviar enlace de recuperación
          b-spinner(v-if="loading" small)
    .rc__actions
      router-link.rc__btn.rc__btn--link(:to="{ name: 'Login' }") Volver al inicio de sesión

  .rc__backdrop(v-if="enviado" @click.self="enviado = false")
    .rc__modal(role="dialog" aria-modal="true" aria-labelledby="rc-enviado-titulo")
      .rc__modal-header
        h2#rc-enviado-titulo.rc__modal-title Revisa tu bandeja de entrada
        button.rc__close(type="button" aria-label="Cerrar" @click="enviado = false")
          img(src="@/assets/recuperar-clave/window-close.svg" alt="")
      img.rc__icon(src="@/assets/recuperar-clave/check-circle.svg" alt="")
      p.rc__text
        | Si el correo ingresado coincide con un usuario activo en el sistema, te enviaremos un enlace para restablecer tu contraseña.
      .rc__actions
        router-link.rc__btn.rc__btn--primary(:to="{ name: 'Login' }") Volver al inicio
</template>

<script>
import { mapActions } from 'vuex'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default {
  data() {
    return {
      email: '',
      loading: false,
      enviado: false,
      errorEmail: '',
    }
  },
  methods: {
    ...mapActions('AuthenticationStore', ['solicitarRecuperacionClave']),

    validar() {
      if (!this.email) return 'Ingresa tu correo'
      if (!EMAIL_REGEX.test(this.email)) return 'Ingresa un correo válido'
      return ''
    },

    async onSubmit() {
      if (this.loading) return
      this.errorEmail = this.validar()
      if (this.errorEmail) return

      this.loading = true
      try {
        await this.solicitarRecuperacionClave({ email: this.email })
        this.enviado = true
      } catch (err) {
        this.errorEmail = err.response?.data?.detail
          || 'No pudimos enviar la solicitud. Intenta nuevamente.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/auth-card.scss';
</style>
